const videoSource2 = [
  {
    id: "video4",
    src: require("./1_4.mp4"),
  },
];

export default videoSource2;
